<template>
  <el-container :style="{height: containerHeight}">
    <el-header class="login-navbar">
      <!-- <div class="logo"></div> -->
      <!-- <div style="float:left;">
        <el-tooltip effect="dark" placement="bottom" :content="active?'隐藏菜单':'展开菜单'">
          <svg :class="active?'tab-active':''" @click="active=!active" style="cursor:pointer;margin:3px;fill:white;" data-v-d2b12fd8="" viewBox="0 0 1024 1024" xmlns="http://www.w3.org/2000/svg" width="64" height="64"><path data-v-d2b12fd8="" d="M408 442h480c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8H408c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zm-8 204c0 4.4 3.6 8 8 8h480c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8H408c-4.4 0-8 3.6-8 8v56zm504-486H120c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h784c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0 632H120c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h784c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zM142.4 642.1L298.7 519a8.84 8.84 0 0 0 0-13.9L142.4 381.9c-5.8-4.6-14.4-.5-14.4 6.9v246.3a8.9 8.9 0 0 0 14.4 7z"></path></svg>
        </el-tooltip>
      </div> -->
      <div class="web" style="margin-right: 30px;">
        <div class="webName">{{$t('txtWebSite')}}</div>
        <div class="webNameEn">{{$t('txtWebSiteEn')}}</div>
      </div>
      <div v-if="(!firstLevel)&&menuList.length>0" style="height:100%;line-height:70px;float: left;display:inline-block;margin:0px 20px 0px 0px;">
        <div style="display:inline-block;">
        <el-dropdown placement="bottom-start" style="top: 0px;font-size: 16px;">
          <div class="over-menu" style="cursor:pointer;height:70px;width:70px;text-align: center;">
            <i class="el-icon-s-grid" style="color:white;font-size:32px;vertical-align: middle;"/>
          </div>
          <el-dropdown-menu slot="dropdown" class="menu-dropdown-all">
            <el-cascader-panel @change="jump(urlMap[$event[1]])" :options="allMenuList" :props="{expandTrigger:'hover',label:'name',value:'id'}"/>
          </el-dropdown-menu>
        </el-dropdown>
        </div>
        <span style="vertical-align: middle;color:white;font-size:22px;line-height:22px;margin:0px 20px;border-right: 2px solid white; padding-right: 10px;">{{firstMenuName}}</span>
      </div>
      <div style="display: inline-block;float: left;height: 70px;overflow: hidden;" v-if="menuList.length>0"  :style="{width:firstLevel?'calc( 100% - 750px)':'calc( 100% - 972px)'}">
        <el-menu :default-openeds="menuIndex" :unique-opened="true" :default-active="menuActive" popper-class="home-menu-eject" mode="horizontal" class="title_menus home-menu" style="width:100%;overflow: auto;text-align: left;">
          <template v-if="firstLevel">
            <el-submenu v-for="(menus,index) in menuList" :key="menus.id" :index="menus.id">
              <template slot="title">{{menus.name}}</template>
              <el-menu-item-group>
                <el-menu-item
                  :key="menusChild.id"
                  :index="menus.id+'-'+menusChild.id"
                  @click="jump(menusChild.url)"
                  v-for="(menusChild,childIndex) in menus.children"
                >{{menusChild.name}}</el-menu-item>
              </el-menu-item-group>
            </el-submenu>
          </template>
          <template v-else>
            <el-menu-item
              class="home-menu-item"
              :key="menusChild.id"
              :index="menusChild.id"
              @click="jump(menusChild.url)"
              v-for="(menusChild,childIndex) in menuList"
            >{{menusChild.name}}</el-menu-item>
          </template>
          <el-dropdown placement="bottom-start" v-if="overflowMenu.length>0" style="font-size: 16px;">
            <div class="over-menu" style="cursor:pointer;height:70px;display: inline-block;width:70px;    text-align: center;">
              <i class="el-icon-menu" style="color:white;font-size:32px;vertical-align: middle;"/>
            </div>
            <el-dropdown-menu slot="dropdown" class="menu-dropdown">
              <el-cascader-panel @change="jump(urlMap[$event[1]||$event[0]])" :options="overflowMenu" :props="{expandTrigger:'hover',label:'name',value:'id'}"/>
            </el-dropdown-menu>
          </el-dropdown>
        </el-menu>
      </div>
      <!-- 用户信息 -->
      <div style="float: right;width: 440px;font-size:18px;">
        <div style="float: left;color: #ffffff;margin:0 0 0 0px;">
          <a :href="Config.portalUrl+'/'">
            <font color="#ffffff">{{$t('txtIndexName')}}</font>
          </a>
        </div>
        <div style="float: left;color: #ffffff;margin:0 0 0 15px;">
          <a :href="Config.portalUrl+'/main'">
            <font color="#ffffff">{{$t('txtWorkBenchName')}}</font>
          </a>
        </div>
        <div style="float: left;color: #ffffff;margin:0 15px 0 15px;">
          <a :href="Config.portalUrl+'/main/homeHelp'">
            <font color="#ffffff">{{$t('txtHelp')}}</font>
          </a>
        </div>
        <div style="float: left;color: #ffffff;margin:0 15px 0 15px;">
          <a href="https://sanygroup.feishu.cn/base/GhBlb8ZL1ahzttsXO2Ccuj58npf?table=ldxTid2hNfFglT0S" target="_blank">
            <font color="#ffffff">我建议</font>
          </a>
        </div>
        <el-dropdown trigger="hover" class="userinfo-n">
          <div class="el-dropdown-link">
            <i class="el-icon-user-solid"></i>
            <i style="font-size: 18px;color: #ffffff;margin: 0 0 0 5px;">{{userName}}</i>
            <i class="el-icon-arrow-down el-icon--right"></i>
          </div>
          <el-dropdown-menu slot="dropdown" class="e-dropdown">
            <!-- <el-dropdown-item>我的消息</el-dropdown-item>
            <el-dropdown-item>设置</el-dropdown-item>-->
            <el-dropdown-item @click.native="logout">{{$t('txtLogoutName')}}</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
    </el-header>

    <el-container>
      <!-- <el-aside v-show="active">
        <el-menu :default-openeds="menuIndex" :unique-opened="true" :default-active="menuActive">
          <el-submenu v-for="(menus,index) in menuList" :key="menus.id" :index="menus.id">
            <template slot="title">{{menus.name}}</template>
            <el-menu-item-group>
              <el-menu-item
                :key="menusChild.id"
                :index="menus.id+'-'+menusChild.id"
                @click="jump(menusChild.url)"
                v-for="(menusChild,childIndex) in menus.children"
              >{{menusChild.name}}</el-menu-item>
            </el-menu-item-group>
          </el-submenu>
          <el-menu-item
            class="menu-special"
            @click="zsk"
          >知识库</el-menu-item>
          <el-menu-item
            class="menu-special"
            @click="sl"
          >经营决策十律</el-menu-item>
          <el-menu-item
            class="menu-special"
            @click="openUrl('http://dmpfr.sany.com.cn')"
          >风险档案</el-menu-item>
        </el-menu>
      </el-aside> -->

      <el-main :style="{height:mainHeight}">
        <template>
          <router-view v-if="show&&pageRole==1"/>
          <!-- <span v-else-if="pageRole!=1">无页面访问权限</span> -->
        </template>
      </el-main>
    </el-container>
  </el-container>
</template>

<script>
import Cookie from 'js-cookie'
import Config from '@/components/Config'
import router from '@/router'
export default {
  name: "Home",
  data() {
    return {
      active:true,
      pageRole:0,
      show:false,
      containerHeight: 0,
      menuList: [],
      sourceMenuList:[],
      menuIndex: [""],
      menuActive: "",
      userName: "",
      overflowMenu:[],
      urlMap:{},
      mainHeight:'1227px',
      firstLevel:true,
      firstMenuName:'',
			allMenuList:[],
			rolePage:['tsArticle','tsComplaint','tsCashGift','tsInterest']
    };
  },
  created() {
    this.firstLevel = window.location.host.endsWith('portal-audit.sany.com.cn')
    if(Cookie.get('oguGuid')){
      this.containerHeight = `${document.documentElement.clientHeight}` + "px";
      this.mainHeight = (window.innerHeight-70)+'px'
      this.show = true
    }
    window.addEventListener('resize', this.resizeMenu)
    // this.changeFixed();
    this.createMenu();
  },
  destroyed(){
    window.removeEventListener('resize', this.resizeMenu)
  },
  beforeCreate(){
		document.title = '廉洁三一'
    this.$axios.get("/api/orgPerson/v0.1/User/getUserInfo").then((res) => {
      var js = res.data;
      if (js.data&&js.errcode == 0) {
      this.userName = js.data.oguName;
      Cookie.set('oguName',js.data.oguName)
      Cookie.set('oguGuid',js.data.oguGuid)
			Cookie.set('uGuid',js.data.uGuid)
			localStorage.setItem('oguGuid',js.data.uGuid)
      Cookie.set('orgGuid',js.data.orgGuid)
      Cookie.set('oguUserid',js.data.oguUserid)
      Cookie.set('isAdmin',("5d9b0c865271453ebba0c96add3b629f,8a14255933ad46bd9f3ffa276d828434".indexOf(js.data.oguGuid)>-1)?true:'')
        // console.log(1111111111111)
        // console.log(Cookie.get('oguGuid'))
      this.containerHeight = `${document.documentElement.clientHeight}` + "px";
      this.mainHeight = (window.innerHeight-70)+'px'
      this.show = true
      } else {
        this.$message({
          showClose: true,
          message: "个人信息获取失败。",
          type: "error",
        });
      }
    });
  },
  mounted() {
    // this.initFocusMenus();
    // setTimeout(()=>{
    //   debugger
    // },5000)
  },
  watch: {},
  methods: {
    resizeMenu(){
      this.mainHeight = (window.innerHeight-70)+'px'
      let menuWidth = window.innerWidth-(this.firstLevel?730:892)
      let maxNum = Math.floor(menuWidth/134)
      // let maxNum = 5
      maxNum = Math.min(Math.max(maxNum,(this.firstLevel?5:2)),8)
      if(this.sourceMenuList.length>maxNum){
        if(menuWidth-(maxNum*134)<100){
          maxNum-=1
        }
        this.overflowMenu = this.sourceMenuList.slice(maxNum)
        this.menuList = this.sourceMenuList.slice(0,maxNum)
        console.log(this.overflowMenu)
      }else{
        this.overflowMenu = []
        this.menuList = this.sourceMenuList
      }
    },
    //设置容器高度
    changeFixed() {
      // this.containerHeight = `${document.documentElement.clientHeight}` + "px"; //获取浏览器可视区域高度
      // let that = this;
      // window.onresize = function () {
      //   this.containerHeight =
      //     `${document.documentElement.clientHeight}` + "px";
      //   that.containerHeight = this.containerHeight;
      // };
    },
    //渲染菜单
    createMenu() {
      this.$axios
        .get(
          "/api/rbac/v0.1/menus/getMenuListByUGuidAndSiteIdAndPid?siteId=0&menuRootId=4aa762dc2ef24d4db21fcb530aa11def"
        )
        .then((res) => {
          var js = res.data;
					let curPathName = window.location.pathname
					let paths = curPathName.split('/')
					let pathEnd = paths[paths.length-1]
          console.log(js);
          if (js.errcode == 0) {
						let hasRouteRole = false
            this.allMenuList = js.data
            let localHref = window.location.href
            let menuList = []
            let sourceMenuList = js.data.map(item=>{
              this.urlMap[item.id] = item.url
              item.children = item.children.map(itm=>{
                this.urlMap[itm.id] = itm.url
                itm.children = undefined
                if((!this.firstLevel)&&itm.url){
                  if(itm.url.endsWith(curPathName)){
                    hasRouteRole = true
                  }
                  if(localHref.startsWith(itm.url)){
                    menuList = item.children
                    this.firstMenuName = item.name
                  }
                }
                return itm
              })
              return item
            });
            if(this.firstLevel){
              this.sourceMenuList = sourceMenuList
            }else{
              if(menuList.length!=0){
                this.sourceMenuList = menuList
              }else{
                this.firstLevel = true
                this.sourceMenuList = sourceMenuList
              }
            }
            console.log(this.pageRole)
            if(this.rolePage.indexOf(pathEnd)==-1||hasRouteRole){
              this.pageRole = 1
						}
						// this.pageRole = 1
            this.resizeMenu()
          } else {
            this.$message({
              showClose: true,
              message: "菜单获取失败，请重试。",
              type: "error",
            });
          }
        });
    },
    //初始化菜单展开
    initFocusMenus() {
      var inPath = window.location.href;
      if (inPath && inPath != null && inPath != undefined) {
        var arr_inPath = inPath.split("?");
        console.log(arr_inPath[0]);
        if (arr_inPath[0]) {
          this.$axios
            .get(
              "/api/rbac/v0.1/menus/getMenusByUrl?url=" +
                encodeURIComponent(arr_inPath[0])
            )
            .then((res) => {
              var js = res.data;
              console.log(js);
              if (js.errcode == 0) {
                if (
                  js.data != null &&
                  js.data != undefined &&
                  js.data != "" &&
                  js.data != "[]"
                ) {
                  let menusList = new Array();
                  menusList = eval(js.data);
                  if (menusList.length > 0) {
                    console.log(menusList[0]);
                    this.menuIndex = ["" + menusList[0].parentId + ""];
                    this.menuActive =
                      menusList[0].parentId + "-" + menusList[0].guid;
                  }
                }
              } else {
                this.$message({
                  showClose: true,
                  message: "单个菜单获取失败，请重试。",
                  type: "error",
                });
              }
            });
        }
      }
    },
    //菜单点击跳转url
    jump(url) {
      if (url && url != null && url != undefined) {
        location.href = url;
      } else {
        this.$message({
          showClose: true,
          message: "菜单的URL未配置。",
          type: "warning",
        });
      }
    },
    //获取用户个人信息
    getUserInfo() {
      
    },
    //退出
    logout() {
      this.$confirm("确认退出?", "提示", {})
        .then(() => {
          this.$axios.post("/api/sso/exit").then((res) => {
            var js = res.data;
            console.log(js);
            if (js.errcode == 0) {
              location.href =
                this.Config.ssoUrl +
                "/exit?refer=" +
                encodeURIComponent(this.Config.portalUrl);
            } else {
              this.warningMsg("网关退出失败。");
            }
          });
        })
        .catch(() => {});
    },
    zsk(){
      window.open("https://rs2flu7c17.work.sany.com.cn/wiki/wikk5DPHAO1GO6KoRiCQovbQOqz")
      // this.$axios
      //   .get("/api/job/v0.1/jobCommon/getNoCrossOriginData2", {
      //       params:{
      //         url:"https://ikm.sany.com.cn:8090/api/sys-authentication/loginService/getLoginSessionId",
      //         loginName:'zhangpeng'
      //       }
      //   })
      //   .then((res) => {
      //       if(res.data&&res.data.sessionId){
      //         window.open("https://rs2flu7c17.work.sany.com.cn/wiki/wikk5DPHAO1GO6KoRiCQovbQOqz")
      //       }else{
      //         this.$message.error("登录失败")
      //       }
      //   })
    },
    sl(){
      window.open("http://10.0.3.123:8081/#/login")
    },
    openUrl(url){
      window.open(url)
    }
  },
};
</script>

<style>
@import "../assets/css/base.css";
@import "../assets/css/mainbody.css";
@import "../assets/css/swiper-3.4.2.min.css";
@import "../assets/font/iconfont.css";
body {
  padding-bottom: 0px;
}
.el-icon-user-solid {
  color: white;
  font-size: 22px;
}
.el-main {
  background-color: #f2f2f2;
}
.el-container {
  border: 0px;
}
.el-header {
  /* background-color: #b3c0d1;
  color: #333;
  line-height: 60px; */
  padding: 0 0 0 0;
  line-height: 70px;
  height: 70px !important;
}
.web {
  float: left;
  font-size: 27px;
  font-weight: bold;
  color: #ffffff;
  margin: 0 0 0 18px;
  letter-spacing: 2px;
  text-align: left;
}
.webName {
  line-height: 27px;
  margin: 20px 0 0 0;
}
.webNameEn {
  height: 14px;
  line-height: 14px;
  font-size: 12px;
  color: #ffffff;
  margin: 4px 0 0 0px;
  opacity: 0.6;
}
.login-navbar .el-aside {
  color: #fff;
  background: #404549;
  width: 190px !important;
  float: left;
}
.el-menu--horizontal .el-menu {
  font-family: Avenir, Helvetica, Arial, sans-serif !important;
  /* color: #fff;
  background: #138cde; */
}
.login-navbar .drop-mdl .drop-mdl-tit{
  background-color: #138cde;
}
.el-submenu {
  text-align: left;
}
.el-menu--horizontal .el-menu{
  min-width: 140px !important;
  width:140px !important;
}
.login-navbar .el-menu .el-submenu__title {
  color: #fff !important;
  background-color: #138cde !important;
  height:70px !important;
  line-height: 70px !important;
  font-size: 18px;
}
.home-menu-item{
  color: #fff !important;
  background-color: #138cde;
  height:70px !important;
  line-height: 70px !important;
  font-size: 18px;
}
.home-menu-item:hover{
  
}
.home-menu-item {
  padding:0px 20px !important;
}
.home-menu-item:hover,.home-menu-item:hover:focus{
  background-color: #006cb5 !important;
}
.el-menu--horizontal .el-menu .el-menu-item,.el-menu--horizontal .el-menu .el-submenu__title {
  color: #303133;
  font-size: 16px;
  padding: 15px 20px;
  line-height: 16px;
  height: 46px;
}
.el-menu--horizontal .el-menu-item:not(.is-disabled):focus,.el-menu--horizontal .el-menu--popup .el-menu-item:not(.is-disabled):hover{
  color:#138cde;
  background-color: #d3e4f9;
}
.login-navbar .el-menu.el-menu--horizontal{
  border: 0px;
}
.el-cascader-node{
  height:46px;
  font-size:16px;
  font-family: Avenir, Helvetica, Arial, sans-serif !important;
}
.login-navbar .el-cascader-node:not(.is-disabled):focus, .el-cascader-node:not(.is-disabled):hover {
  background-color: #d3e4f9 ;
  color: #138cde;
}
.login-navbar .el-cascader-node.in-active-path, .el-cascader-node.is-active, .el-cascader-node.is-selectable.in-checked-path{
  background-color: #d3e4f9 !important;
  color:#138cde !important
}
.menu-dropdown{
  /* background-color: #138cde; */
}
.login-navbar .el-cascader-menu{
  min-width: 180px;
  width: 180px;
}
.login-navbar .over-menu:hover{
  background-color: #006cb5 ;
}
.el-menu-item:hover {
  /* color: #404549;
  background-color: #006cb5 !important; */
}
.login-navbar .el-submenu__title:hover {
  color: #404549;
  background-color: #006cb5 !important;
}
.login-navbar .el-menu-item {
  padding-right: 0px;
}
.el-menu-item-group__title {
  color: #fff;
  display: none;
}
.el-menu-item-group {
  background: rgba(0, 0, 0, 0.1);
  opacity: 0.8;
}
.login-navbar .title_menus{
  background-color: #138cde !important;
}
.el-menu {
  width: 190px;
  border: 0px;
  overflow: hidden;
}
.el-icon--right {
  margin-left: 5px;
  color: #eeeeee;
  opacity: 0.6;
}
.login-navbar .el-dropdown-menu {
  top: 60px;
  left: 10px;
}
.userinfo-n {
  float: right;
  margin-right: 10px;
}
.userinfo-n .iconfont {
  margin: 0 0 0 10px;
  color: #ffffff;
}
.login-navbar .el-dropdown-link {
  height: 60px;
}
.tab-active{
  -webkit-transform: rotateY(180deg);
}
.el-cascader-panel.is-bordered{
  border:0px;
}

.login-navbar .menu-special{
	height: 50px;
	line-height: 50px;
	min-width: 200px;
	color:white !important;
	text-align: left;
	
}
.login-navbar .menu-special:hover{
	color:black !important;
}
.login-navbar .menu-special:focus{
	color:black !important;
}


.tb-mini td{
    height:48px !important;
    padding:0px !important;
}
.el-table__body,
.el-table__footer,
.el-table__header {
  border-collapse: collapse;
}
.menu-dropdown .el-cascader-menu__wrap{
  height:400px;
}
.menu-dropdown-all .el-cascader-menu__wrap{
  height:665px;
}
/* .login-navbar{
  box-shadow: 0px 3px 5px grey;
  margin-bottom:5px;
}
.login-navbar:hover{
  box-shadow: 0px 5px 15px grey;
} */
</style>
